import React from "react";
import ProjectCard from "./ProjectCard";
import projectsData from "../Data/ProjectsData";

function Projects() {
  return (
    <section id="projects" className="py-5 bg-light-gray">
      <div className="container py-5">
        <h2 className="text-center fw-bold section-title">أعمالي</h2>

        <div className="row mt-5">
          {projectsData.map((project) => (
            <ProjectCard
              key={project.id}
              id={project.id}
              icon={project.icon}
              title={project.title}
              description={project.description}
              tags={project.tags}
              gradient={project.gradient}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;
